module.exports = __webpack_public_path__ + "img/voucher4.852de0c3.png";